import { oauthHelpers, routerHelpers } from '@approvalmax/utils';
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { routingService } from 'services/routing';
import { getPath, Path } from 'urlBuilder';

export const useAirwallexOauthRedirectPageData = () => {
    const search = useLocation().search;
    const code = routerHelpers.getParamAsString(search, 'code', '');
    const state = routerHelpers.getParamAsString(search, 'state', '');

    useEffect(() => {
        const { uiState, backendState } = oauthHelpers.decodeOAuthState<{ companyId: string }>(state);

        routingService.replace(getPath(Path.companyInfo, uiState.companyId, { code, state: backendState }));
    }, [code, state]);
};
